<template>
  <div class="home">

    <h1 class="title is-1">Christian Accountability v0.4</h1>

    <hr>

    <div v-for="(category, index) in questions.categories" v-bind:key="index">
      <category :categoryData="category" :viewResponses="true"/>
    </div>


  </div>
</template>

<script>
import axios from "axios"
import category from "../components/Category.vue"

export default {
  name: "Report",
  components: {
    category: category
  },
  data() {
    return {
      questions: {
        categories: []
      }
    }
  },
  mounted() {
    this.getReport(this.$route.params.id);
  },
  methods: {
    getReport(id) {
      axios.get(`https://vps.stouthearted.com/couchdb/accountability_reports/${id}`)
        .then(response => {
          this.questions = response.data
        })
    }
  }
}
</script>
